import { api } from "@/common/http/axios";

/** Overview 页项目资源汇总（`GET /project/overview/resources`）。 */

/** 单行资源指标(CPU / 内存 / GPU / 运行中任务)。上游缺字段时 used/quota 为 null。 */
export interface OverviewResourceMetric {
  used: number | null;
  quota: number | null;
  unit: string;
}

export interface OverviewResourceParams {
  max_parallel_subtasks: number | null;
  tasks_per_worker: number | null;
  tasks_per_pod: number | null;
}

export interface OverviewResourceItem {
  project_id: string;
  display_name: string;
  scope: string;
  /** key: cpu / memory / gpu / tasks */
  resources: Record<string, OverviewResourceMetric>;
  params: OverviewResourceParams;
  /** 非空表示 CF 拉取该 project 失败;前端渲染灰色错误态。 */
  error: string | null;
}

export interface OverviewResourceResponse {
  as_of: string;
  projects: OverviewResourceItem[];
}

export const getOverviewProjectResources = async (): Promise<OverviewResourceResponse> => {
  const response = await api.get("/project/overview/resources");
  return response.data?.data as OverviewResourceResponse;
};

/** Overview 页仿真类型运行时状态(`GET /overview/simtype-runtime`)。 */

export interface SimTypeRuntimeVo {
  /** planning / perception */
  sim_type: string;
  queued: number;
  compiling: number;
  running: number;
  done_today: number;
  /** 0..1 之间的通过率;done_today=0 时为 null */
  pass_rate_today: number | null;
}

export interface SimTypeRuntimeResponse {
  as_of: string;
  items: SimTypeRuntimeVo[];
}

export const getSimTypeRuntime = async (): Promise<SimTypeRuntimeResponse> => {
  const response = await api.get("/overview/simtype-runtime");
  return response.data?.data as SimTypeRuntimeResponse;
};

/** Overview 页仿真类型最近 N 天场景数(`GET /overview/simtype-trend?days=7`)。 */

export interface SimTypeTrendPoint {
  /** YYYY-MM-DD */
  date: string;
  scene_count: number;
  /** 当日累计行驶里程,单位:米(后端不换算,前端展示层自行转 km) */
  mileage: number;
}

export interface SimTypeTrendVo {
  sim_type: string;
  points: SimTypeTrendPoint[];
  total: number;
  /** 期间累计行驶里程 = SUM(points.mileage),单位:米 */
  total_mileage: number;
  /** (本期 total - 上期 total) / 上期 total,上期为 0 时为 null */
  delta_vs_prev_pct: number | null;
}

export interface SimTypeTrendResponse {
  as_of: string;
  days: number;
  items: SimTypeTrendVo[];
}

export const getSimTypeTrend = async (
  days: number = 7,
): Promise<SimTypeTrendResponse> => {
  const response = await api.get("/overview/simtype-trend", { params: { days } });
  return response.data?.data as SimTypeTrendResponse;
};
